import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

/* Handles toggling the visibility of addon product protection plans */

registerComponent(
  "addon-protection-plans",
  class AddonProtectionPlans extends WYATTElement {
    constructor() {
      super();

      this.syncPlans = this.syncPlans.bind(this);
    }

    connectedCallback() {
      this.subscribe(WYATT.PubSub.events.addonSelectionChanged, this.syncPlans);

      this.syncPlans();
    }

    get selectedAddonIDs() {
      const options = document.querySelectorAll(
        "[data-variant-option]:checked",
      );
      return new Set(Array.from(options, ({ value }) => value));
    }

    syncPlans() {
      this.querySelectorAll("[data-protection-plan-addon-id]").forEach(
        (container) => {
          const isSelected = this.selectedAddonIDs.has(
            container.getAttribute("data-protection-plan-addon-id"),
          );

          container.hidden = !isSelected;
        },
      );
    }
  },
);
